/* eslint-disable */
import { connect } from 'react-redux';
import {
	// useCallback,
	useEffect,
	useMemo,
	useState,
} from 'react';
import moment from 'moment';
import drawerActions from '../../../Actions/drawer.actions';
import BaseDrawer from '../BaseDrawer/BaseDrawer';
import { useAuth } from '@/Components/Auth/Login/auth';
import { Label } from '@/Components/ui/label';
import { UYDateRange } from '@/Components/Forms/Payment Settlements/Calender/UYDateRange';
import {
	Tabs, TabsList, TabsTrigger
} from '@/Components/ui/tabs';
import inventoryAnalyticsServices from '@/Services/Analytics Services/inventory-analytics.services';
import ScanWiseTable from './ScanWiseTable';
import DayWiseTable from './DayWiseTable';
import { BackdropLoader } from '@/Components/Loaders';
import ProcessDayWiseTable from './ProcessDayWiseTable';
import ProcessScanWiseTable from './ProcessScanWiseTable';
import AssetScanWiseTable from './AssetScanWiseTable';
import { QrWiseTable } from './qrWiseTable';
import PackScanWiseTable from './PackScanWiseTable';
import PackDayWiseTable from './PackDayWiseTable';

const StockHistoryDrawer = (props) => {
	// eslint-disable-next-line no-unused-vars
	const { show, data, toggleDrawer, stores } = props;
	const { selectedStore = null } = data;
	const { userConfig = {}, appConfig = {} } = useAuth();
	const { userRolesDict } = userConfig || {};
	const validRoles = Object?.values?.(userRolesDict ?? {}).includes('INTERNAL') || Object?.values?.(userRolesDict ?? {}).includes('CXO Office') || Object?.values?.(userRolesDict ?? {}).includes('internal') || Object?.values?.(userRolesDict ?? {}).includes('Procurement');
	const { measurement } = appConfig?.configs ?? {};
	const [loading, setLoading] = useState(false);

	const [skuTrail, setSkuTrail] = useState([]);
	// eslint-disable-next-line no-unused-vars
	const [dataType, setDataType] = useState('scan_wise');
	const [dateRange, setDateRange] = useState({
		from: new Date(),
		to: new Date(),
		active: false,
	});

	const onClose = () => {
		toggleDrawer(false, {});
	};
	const fetchAssetTrail = async (filters) => {
		setLoading(true);
		try {
			const req = {
				data: {
					storeId: selectedStore?.id,
					assetTypeId: data?.itemDetails?.assetTypeId,
					dateRangeFilter: {
						from: moment(filters?.dateRange?.from).format('YYYY-MM-DD'),
						to: moment(filters?.dateRange?.to).format('YYYY-MM-DD'),
					},
				},
			};
			const assetResponse = await inventoryAnalyticsServices.fetchAssetTrail(req);
			if (assetResponse?.statusCode === 200) {
				setSkuTrail(assetResponse?.data);
			}
		} catch (error) {
			console.log('erorrr', error);
		} finally {
			setLoading(false);
		}
	};

	const fetchScanWiseTrail = async (filters) => {
		setLoading(true);
		try {
			const response = await inventoryAnalyticsServices.scanWiseSkuTrail({
				data: {
					variantId: data?.itemDetails?.variantId,
					productId: data?.itemDetails?.id,
					...(data?.type !== "PROCESS_REPORT" && data?.assetId && {
						assetId: data?.assetId,
					}),
					...(data?.type === 'PROCESS_REPORT' && {
						processId: data?.processId,
					}),
					...(data?.type !== 'PROCESS_REPORT' && {
						storeId: data?.itemDetails?.storeId,
					}),
					dateRangeFilter: {
						from: moment(filters?.dateRange?.from).format(
							'YYYY-MM-DD'
						),
						to: moment(filters?.dateRange?.to).format('YYYY-MM-DD'),
					},
				},
			}, data?.type === 'PROCESS_REPORT' ? 'PROCESS_REPORT' : null);
			if (response?.responseCode === 'SS-001') {
				setSkuTrail(response?.data);
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log('erorrr', error);
		} finally {
			setLoading(false);
		}
	};
	const fetchDayWiseTrail = async (filters) => {
		setLoading(true);
		try {
			const response = await inventoryAnalyticsServices.dayWiseSkuTrail({
				data: {
					...(!data?.allVariants && data?.itemDetails?.variantId && {
						variantId: data?.itemDetails?.variantId,
					}),
					...(data?.type !== "PROCESS_REPORT" && data?.assetId && {
						assetId: data?.assetId,
					}),
					productId: data?.itemDetails?.id,
					...(data?.type === 'PROCESS_REPORT' && {
						processId: data?.processId,
					}),
					...(data?.type !== 'PROCESS_REPORT' && {
						storeId: data?.itemDetails?.storeId,
					}),
					dateRangeFilter: {
						from: moment(filters?.dateRange?.from).format(
							'YYYY-MM-DD'
						),
						to: moment(filters?.dateRange?.to).format('YYYY-MM-DD'),
					},
				},
			}, data?.type === 'PROCESS_REPORT' ? 'PROCESS_REPORT' : null);
			if (response?.responseCode === 'SS-001') {
				setSkuTrail(response?.data);
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log('erorrr', error);
		} finally {
			setLoading(false);
		}
	};

	const fetchQRTabData = async () => {
		setLoading(true);
		try {
			const response = await inventoryAnalyticsServices.qrTabData({
				data: {
					...(!data?.allVariants && data?.itemDetails?.variantId && {
						variantId: data?.itemDetails?.variantId,
					}),
					storeId: data?.itemDetails?.storeId,
					productId: data?.itemDetails?.id,
				},
			})
			if (response?.responseCode === 'SS-001') {
				setSkuTrail(response?.data);
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log('erorrr', error);
		} finally {
			setLoading(false);
		}
	};

	// Pack Trail fetch functions
	const fetchPackScanWiseTrail = async (filters) => {
		setLoading(true);
		try {
			const response = await inventoryAnalyticsServices.packScanWiseTrail({
				data: {
					packId: data?.packDetails?.packId,
					packSize: data?.packDetails?.packSize,
					productId: data?.itemDetails?.id,
					variantId: data?.itemDetails?.variantId,
					storeId: data?.selectedStore,
					dateRangeFilter: {
						from: moment(filters?.dateRange?.from).format('YYYY-MM-DD'),
						to: moment(filters?.dateRange?.to).format('YYYY-MM-DD'),
					},
				},
			});
			if (response?.responseCode === 'SS-001') {
				setSkuTrail(response?.data);
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log('error', error);
		} finally {
			setLoading(false);
		}
	};

	const fetchPackDayWiseTrail = async (filters) => {
		setLoading(true);
		try {
			const response = await inventoryAnalyticsServices.packDayWiseTrail({
				data: {
					packId: data?.packDetails?.packId,
					packSize: data?.packDetails?.packSize,
					productId: data?.itemDetails?.id,
					variantId: data?.itemDetails?.variantId,
					storeId: data?.selectedStore,
					dateRangeFilter: {
						from: moment(filters?.dateRange?.from).format('YYYY-MM-DD'),
						to: moment(filters?.dateRange?.to).format('YYYY-MM-DD'),
					},
				},
			});
			if (response?.responseCode === 'SS-001') {
				setSkuTrail(response?.data);
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log('error', error);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		setSkuTrail([]);
		setDataType('scan_wise');
	}, [show]);

	useEffect(() => {
		if (data?.type === 'ASSET_REPORT') {
			fetchAssetTrail({
				dateRange: {
					from: dateRange?.from,
					to: dateRange?.to,
				},
			});
			return;
		}
		// Handle PACKS type - fetch pack trail on mount
		if (data?.type === 'PACKS' && show) {
			const defaultDateRange = {
				from: moment().startOf('day').subtract(7, 'days').toDate(),
				to: moment().startOf('day').toDate(),
			};
			setDateRange({
				...defaultDateRange,
				active: true,
			});
			if (dataType === 'scan_wise') {
				fetchPackScanWiseTrail({ dateRange: defaultDateRange });
			}
			if (dataType === 'day_wise') {
				fetchPackDayWiseTrail({ dateRange: defaultDateRange });
			}
			return;
		}
	}, [data?.type, show]);

	useEffect(() => {
		let updatedAt = new Date();
		if (data?.type == "PACKS") {
			return;
		}
		if (data?.itemDetails?.lastUpdatedAt) {
			updatedAt = new Date(data?.itemDetails?.lastUpdatedAt);
		}
		if (data?.type === 'PROCESS_REPORT' || data?.type === '') {
			const dateRangeTemp = {
				from: moment(data?.lastUpdatedAt).startOf('day').subtract(10, 'days').toDate(),
				to: moment(data?.lastUpdatedAt).startOf('day').toDate(),
			};
			setDateRange({
				...dateRangeTemp,
				active: true,
			});
			// if (dataType === 'scan_wise') {
			// 	fetchScanWiseTrail({
			// 		dateRange: dateRangeTemp,
			// 		processId: data?.processId,
			// 	});
			// }
			// if (dataType === 'day_wise') {
			// 	fetchDayWiseTrail({
			// 		dateRange: dateRangeTemp,
			// 		processId: data?.processId,
			// 	});
			// }
			return;
		}
		if (show && data?.itemDetails?.skuType === 'PRODUCT') {
			setDateRange({
				from: moment(updatedAt).startOf('day').subtract(6, 'days').toDate(),
				to: moment(updatedAt).startOf('day').toDate(),
				active: true,
			});
			if (dataType === 'scan_wise') {
				fetchScanWiseTrail({
					dateRange: {
						from: moment(updatedAt)
							.startOf('day')
							.subtract(6, 'days')
							.toDate(),
						to: moment(updatedAt).startOf('day').toDate(),
					},
				});
			}
			if (dataType === 'day_wise') {
				fetchDayWiseTrail({
					dateRange: {
						from: moment(updatedAt)
							.startOf('day')
							.subtract(6, 'days')
							.toDate(),
						to: moment(updatedAt).startOf('day').toDate(),
					},
				});
			}
		} else if (show && ['INGREDIENT', 'PACKAGING', 'OTHER']?.includes(data?.itemDetails?.skuType)) {
			setDateRange({
				from: moment(updatedAt)
					.startOf('day')
					.subtract(1, 'month')
					.toDate(),
				to: moment(updatedAt).startOf('day').toDate(),
				active: true,
			});
			if (dataType === 'scan_wise') {
				fetchScanWiseTrail({
					dateRange: {
						from: moment(updatedAt)
							.startOf('day')
							.subtract(1, 'month')
							.toDate(),
						to: moment(updatedAt).startOf('day').toDate(),
					},
				});
			}
			if (dataType === 'day_wise') {
				fetchDayWiseTrail({
					dateRange: {
						from: moment(updatedAt)
							.startOf('day')
							.subtract(1, 'month')
							.toDate(),
						to: moment(updatedAt).startOf('day').toDate(),
					},
				});
			}
		}
	}, [show, data?.itemDetails?.skuType, data?.type]);

	const dateRangeFilterArray = useMemo(() => {
		return [
			{
				startDate: dateRange.from,
				endDate: dateRange.to,
				key: 'selection',
			},
		];
	}, [dateRange]);

	const setDate = (newDate) => {
		const { startDate: from, endDate: to } = newDate?.selection ?? {};

		setDateRange({
			active: true,
			from,
			to,
		});
		if (data?.type === 'ASSET_REPORT') {
			fetchAssetTrail({
				dateRange: {
					from,
					to,
				},
			});
		} else if (data?.type === 'PACKS') {
			// Handle PACKS type date range change
			if (dataType === 'scan_wise') {
				fetchPackScanWiseTrail({
					dateRange: {
						from,
						to,
					},
				});
			}
			if (dataType === 'day_wise') {
				fetchPackDayWiseTrail({
					dateRange: {
						from,
						to,
					},
				});
			}
		} else {
			if (dataType === 'scan_wise') {
				fetchScanWiseTrail({
					dateRange: {
						from,
						to,
					},
				});
			}
			if (dataType === 'day_wise') {
				fetchDayWiseTrail({
					dateRange: {
						from,
						to,
					},
				});
			}
		}
	};
	const renderBtns = () => {
		return (
			<div className='flex justify-end gap-2 text-sm font-semibold'>
				Current Stock : {data?.currentStock}
			</div>
		);
	};
	return (
		<BaseDrawer
			style={{
				width: '80%',
			}}
			header={data?.heading}
			open={show}
			onClose={onClose}
			renderBtns={renderBtns}
			size='full'
		>
			<BackdropLoader isLoading={loading} showProgress />
			<div className='w-full flex justify-between items-center px-2 py-4'>
				{data?.type !== 'ASSET_REPORT' && (
					<div className='flex flex-col gap-1'>
						<Tabs
							value={dataType}
							onValueChange={(value) => {
								setDataType(value);
								setSkuTrail([]);
								// Handle PACKS type
								if (data?.type === 'PACKS') {
									if (value === 'scan_wise') {
										fetchPackScanWiseTrail({
											dateRange: {
												from: dateRange?.from,
												to: dateRange?.to,
											},
										});
									}
									if (value === 'day_wise') {
										fetchPackDayWiseTrail({
											dateRange: {
												from: dateRange?.from,
												to: dateRange?.to,
											},
										});
									}
									return;
								}
								if (value === 'scan_wise') {
									fetchScanWiseTrail({
										dateRange: {
											from: dateRange?.from,
											to: dateRange?.to,
										},
									});
								}
								if (value === 'day_wise') {
									fetchDayWiseTrail({
										dateRange: {
											from: dateRange?.from,
											to: dateRange?.to,
										},
									});
								}
								if (value === 'qr_tab') {
									fetchQRTabData();
								}
							}}
							defaultValue={dataType}
						>
							<TabsList className=''>
								<TabsTrigger
									className='data-[state=active]:bg-uy-color'
									value='scan_wise'
								>
									Scan-Wise
								</TabsTrigger>
								<TabsTrigger
									className='data-[state=active]:bg-uy-color'
									value='day_wise'
								>
									Day-Wise
								</TabsTrigger>
								{data?.showQRTab && validRoles && (
									<TabsTrigger
										className='data-[state=active]:bg-uy-color'
										value='qr_tab'
									>
										Available Stock
									</TabsTrigger>
								)}
							</TabsList>
						</Tabs>
					</div>
				)}
				{
					selectedStore?.title && (
						<div className='text-lg font-bold tracking-wide text-gray-800 bg-gray-100 px-4 py-2 rounded-lg shadow-sm'>
							{selectedStore?.title}
						</div>
					)
				}
				{dataType !== 'qr_tab' && (
					<div className='flex gap-2'>
						<div className='flex flex-col gap-1'>
							<Label>Select Stock In Range</Label>
							<UYDateRange
								disabled={false}
								dateRanges={dateRangeFilterArray}
								onDateRangeChange={setDate}
								enableOnlyBackwardSelection
								MAX={32}
							/>
						</div>
					</div>
				)}
			</div>
			<div className='w-full overflow-auto !text-xs'>
				{
					data?.type === 'ASSET_REPORT' ? (
						<AssetScanWiseTable data={skuTrail} />
					) : (
						data?.type === 'PROCESS_REPORT' ? (
							<>
								{dataType === 'scan_wise' && (
									<ProcessScanWiseTable
										allVariants={data?.allVariants}
										itemDetails={data?.itemDetails}
										data={skuTrail}
										measurement={measurement}
									/>
								)}
								{dataType === 'day_wise' && (
									<ProcessDayWiseTable
										allVariants={data?.allVariants}
										itemDetails={data?.itemDetails}
										data={skuTrail}
										measurement={measurement}
									/>
								)}
							</>
						) : data?.type === 'PACKS' ? (
							<>
								{dataType === 'scan_wise' && (
									<PackScanWiseTable
										itemDetails={data?.itemDetails}
										packDetails={data?.packDetails}
										data={skuTrail}
									/>
								)}
								{dataType === 'day_wise' && (
									<PackDayWiseTable
										itemDetails={data?.itemDetails}
										packDetails={data?.packDetails}
										data={skuTrail}
									/>
								)}
							</>
						) : (
							<>
								{dataType === 'scan_wise' && (
									<ScanWiseTable
										itemDetails={data?.itemDetails}
										data={skuTrail}
										measurement={measurement}
									/>
								)}
								{dataType === 'day_wise' && (
									<DayWiseTable
										itemDetails={data?.itemDetails}
										data={skuTrail}
										measurement={measurement}
									/>
								)}
								{dataType === 'qr_tab' && (
									<QrWiseTable
										itemDetails={data?.itemDetails}
										data={skuTrail}
										measurement={measurement}
									/>
								)}
							</>
						)
					)
				}
			</div>
		</BaseDrawer>
	);
};

const mapStateToProps = (state) => {
	const { show, data } = state?.drawer?.stockHistoryDrawer;
	const stores = state?.form?.STORES?.data?.LIST;
	return {
		show,
		data,
		stores,
	};
};

const mapDispatchToProps = {
	toggleDrawer: drawerActions.toggleStockHistoryDrawer,
};

export default connect(mapStateToProps, mapDispatchToProps)(StockHistoryDrawer);
